//@ts-nocheck
import { defineMessages } from 'react-intl';

export default defineMessages({
  IMPERSONATING: 'Impersonating',
});
